import React, { useState, useRef } from "react";
import { createPost, uploadMedia } from "../actions/index";
import Video from "../../../Images/video-small.png";
import Camera from "../../../Images/camera-small.png";
import Events from "../../../Images/Events.png";
import Links from "../../../Images/Links.png";
import Documents from "../../../Images/Documents.png";

const CreatePostModal = ({ onClose, currentUser, userId }) => {
  const [postText, setPostText] = useState("");
  const [media, setMedia] = useState<File | null>(null); // Single file state
  const [privacy, setPrivacy] = useState("Friends");
  const [error, setError] = useState("");

  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const documentInputRef = useRef(null);

  const handleSubmit = async () => {
    try {
      let imageUrl: string | undefined = undefined;
      let videoUrl: string | undefined = undefined;

      if (media) {
        const folder = media.type.startsWith("video/")
          ? "posts/videos"
          : "posts/images";

        const url = await uploadMedia(media, folder);

        if (media.type.startsWith("video/")) {
          videoUrl = url;
        } else {
          imageUrl = url;
        }
      }

      await createPost(
        postText,
        currentUser?.userUID || userId,
        currentUser?.displayName,
        imageUrl,
        videoUrl
      );

      onClose();
    } catch (error) {
      console.error("Error creating post:", error);
      setError("Failed to create post. Please try again.");
    }
  };

  const handleMediaUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError("");
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      // Validate file type
      if (!file.type.startsWith("image/") && !file.type.startsWith("video/")) {
        setError("Please select an image or video file");
        return;
      }

      // Clear previous media and set new one
      setMedia(file);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          width: "90%",
          maxWidth: "600px",
        }}
      >
        {/* Modal header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            borderBottom: "1px solid #e4e6eb",
            color: "#1c1e21",
          }}
        >
          <h2 style={{ fontSize: "20px", fontWeight: "600" }}>Create post</h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              color: "#65676b",
            }}
          >
            ×
          </button>
        </div>

        {/* Modal body */}
        <div style={{ padding: "16px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#3b82f6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: "bold",
                marginRight: "12px",
                overflow: "hidden",
              }}
            >
              {currentUser?.photoURL ? (
                <img
                  src={currentUser?.photoURL}
                  alt="Profile"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                currentUser?.displayName?.substring(0, 2).toUpperCase() || "US"
              )}
            </div>
            <div>
              <div
                style={{
                  fontWeight: "600",
                  color: "#1c1e21",
                }}
              >
                {currentUser?.displayName || "User"}
              </div>
            </div>
          </div>

          <textarea
            value={postText}
            onChange={(e) => setPostText(e.target.value)}
            placeholder={`What's on your mind, ${
              currentUser?.displayName || "User"
            }?`}
            style={{
              width: "100%",
              minHeight: "100px",
              border: "none",
              outline: "none",
              fontSize: "16px",
              resize: "none",
              marginBottom: "16px",
            }}
          />

          {/* Media preview if selected */}
          {media && (
            <div
              style={{
                position: "relative",
                marginBottom: "16px",
                padding: "12px",
                backgroundColor: "#f0f2f5",
                borderRadius: "8px",
              }}
            >
              <div style={{ fontWeight: "500", marginBottom: "8px" }}>
                {media.name} ({media.type.split("/")[0]})
              </div>
              <button
                onClick={() => setMedia(null)}
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  background: "rgba(0,0,0,0.5)",
                  border: "none",
                  borderRadius: "50%",
                  width: "24px",
                  height: "24px",
                  color: "white",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ×
              </button>
            </div>
          )}

          {/* Action buttons row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              marginTop: "16px",
              padding: "12px 0",
              borderTop: "1px solid #e4e6eb",
              borderBottom: "1px solid #e4e6eb",
            }}
          >
            <button
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#606770",
                fontWeight: "500",
                fontSize: "15px",
                padding: "8px",
              }}
              onClick={() => videoInputRef.current?.click()}
            >
              <img src={Video} width="20px" height="20px" alt=""></img> Video
            </button>

            <button
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#606770",
                fontWeight: "500",
                fontSize: "15px",
                padding: "8px",
              }}
              onClick={() => imageInputRef.current?.click()}
            >
              <img src={Camera} width="20px" height="20px" alt=""></img> Photos
            </button>

            {/* <button
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#606770',
                fontWeight: '500',
                fontSize: '15px',
                padding: '8px',
              }}
            >
              <img src={Events} width="20px" height="20px" alt=""></img> Events
            </button>

            <button
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#606770',
                fontWeight: '500',
                fontSize: '15px',
                padding: '8px',
              }}
            >
              <img src={Links} width="20px" height="20px" alt=""></img> Links
            </button> */}

            <button
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#606770",
                fontWeight: "500",
                fontSize: "15px",
                padding: "8px",
              }}
              onClick={() => documentInputRef.current?.click()}
            >
              <img src={Documents} width="20px" height="20px" alt=""></img>{" "}
              Documents
            </button>
          </div>

          {/* Hidden file inputs */}
          <input
            type="file"
            ref={imageInputRef}
            style={{ display: "none" }}
            accept="image/*"
            onChange={handleMediaUpload}
          />
          <input
            type="file"
            ref={videoInputRef}
            style={{ display: "none" }}
            accept="video/*"
            onChange={handleMediaUpload}
          />
          <input
            type="file"
            ref={documentInputRef}
            style={{ display: "none" }}
            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
            onChange={handleMediaUpload}
          />

          {error && (
            <div style={{ color: "red", marginTop: "16px" }}>{error}</div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              marginTop: "16px",
              paddingTop: "16px",
            }}
          >
            <button
              onClick={handleSubmit}
              style={{
                padding: "8px 16px",
                backgroundColor: postText || media ? "#3b82f6" : "#e4e6eb",
                color: postText || media ? "white" : "#bcc0c4",
                border: "none",
                borderRadius: "6px",
                fontWeight: "600",
                cursor: postText || media ? "pointer" : "not-allowed",
              }}
              disabled={!postText && !media}
            >
              Post
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePostModal;
